import { render, staticRenderFns } from "./partyBPage.vue?vue&type=template&id=dfda3078&scoped=true"
import script from "./partyBPage.vue?vue&type=script&lang=js"
export * from "./partyBPage.vue?vue&type=script&lang=js"
import style0 from "./partyBPage.vue?vue&type=style&index=0&id=dfda3078&prod&lang=css"
import style1 from "./partyBPage.vue?vue&type=style&index=1&id=dfda3078&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfda3078",
  null
  
)

export default component.exports